// extracted by mini-css-extract-plugin
module.exports = {"button":"VoxFeedFeedbackForm__button___3Vctn","selected":"VoxFeedFeedbackForm__selected___2XwBN"};